import { render, staticRenderFns } from "./MemoryYjjM.vue?vue&type=template&id=b9afbf2a&scoped=true&"
import script from "./MemoryYjjM.vue?vue&type=script&lang=js&"
export * from "./MemoryYjjM.vue?vue&type=script&lang=js&"
import style0 from "./MemoryYjjM.vue?vue&type=style&index=0&id=b9afbf2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9afbf2a",
  null
  
)

export default component.exports